import { ValidatorProvider } from '@dofleini/validator';

export const ipAndMaskRegex = /^(((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])(((\/([4-9]|[12][0-9]|3[0-2]))?)|\s?-\s?((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))))(,\s?|$))+/;

export const ipAndMaskRegexRuler = {
  validator(rule, value = '') {
    if (!value || ipAndMaskRegex.test(value)) {
      return Promise.resolve();
    }

    const message = rule.message || 'validateMessages.ipAndMaskRegex';

    return Promise.reject(ValidatorProvider.t(message));
  },
};
